import { IConversation } from '../../models/IConversation';

function generateSuccessImportTestCaseMessage(replacesConversationsCount: number, conversations: IConversation[]) {
    const conversationsCount = conversations.length;
    let verb = conversationsCount === 1 ? 'was' : 'were';
    let msg = '';

    if (replacesConversationsCount === 0) {
        msg = `${conversationsCount} test case${conversationsCount > 1 ? 's' : ''} ${verb} added`;
    } else {
        if (replacesConversationsCount > 0) {
            verb = replacesConversationsCount === 1 ? 'was' : 'were';
            msg += `${replacesConversationsCount} test case${replacesConversationsCount > 1 ? 's' : ''} ${verb} replaced`;
            if (conversationsCount > replacesConversationsCount) {
                verb = (conversationsCount - replacesConversationsCount) === 1 ? 'was' : 'were';
                msg += `, ${conversations.length - replacesConversationsCount} ${verb} added`;
            }
        }
    }

    return msg;
}

export default generateSuccessImportTestCaseMessage;
